import React from "react";
import { Box, Typography, IconButton, Tooltip, Link } from "@mui/material";
import { DeleteOutline as DeleteOutlineIcon } from "@mui/icons-material";

const linkifyReason = (reason) => {
  const text = String(reason || "");
  const fileLinkRe =
    /(https:\/\/(?:github\.com|gitlab\.com|bitbucket\.org)[^\s]+)/gi;
  const parts = text.split(fileLinkRe);
  return parts.map((part, index) => {
    if (!/^https:\/\/(?:github\.com|gitlab\.com|bitbucket\.org)/i.test(part)) {
      return part;
    }
    return (
      <Link
        key={`${part}-${index}`}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        onClick={(event) => event.stopPropagation()}
      >
        {part}
      </Link>
    );
  });
};

const ResourceReasonCell = ({ 
  reason, 
  hasException, 
  onDelete, 
  disabled = false,
  hasGlobalException = false,
  isBulkMode = false,
  isResourceSelected = false
}) => {
  const tooltipTitle = disabled 
    ? (isBulkMode && isResourceSelected ? "Deselect to delete individual exception" : "Cannot delete exception") 
    : "Delete exception";

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, width: "100%" }}>
      <Typography 
        variant="body2" 
        sx={{ 
          fontWeight: 500, 
          fontSize: "0.875rem",
          whiteSpace: "normal",
          wordBreak: "break-word",
          lineHeight: 1.5,
          flex: 1
        }}
      >
        {linkifyReason(reason)}
      </Typography>
      {hasException && !hasGlobalException && (
        <Tooltip title={tooltipTitle} arrow>
          <span>
            <IconButton
              size="small"
              onClick={onDelete}
              disabled={disabled}
              sx={{
                color: "#d32f2f",
                opacity: disabled ? 0.4 : 0.7,
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "rgba(211, 47, 47, 0.08)",
                  opacity: 1,
                  transform: "scale(1.1)"
                },
                "&:disabled": {
                  opacity: 0.3
                }
              }}
            >
              <DeleteOutlineIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default ResourceReasonCell;

